import InputCurrencyMasking from './InputCurrencyMasking';

export default InputCurrencyMasking;